import { registerPlugin } from '@capacitor/core';

import { isNativePlatform } from './capacitorPlatform';


const NativeOfflineSync = registerPlugin('NativeOfflineSync');

// El espejo legacy no comparte lease/identidad/recibos con el motor común.
// La cola durable JS conserva las intenciones y se ejecuta al abrir/reanudar.
export function buildOperations() {
    return [];
}
export async function mirrorNativeOfflineQueue({ token, drafts, media, operations }) {
    if (!isNativePlatform() || !token) {
        return false;
    }

    const nativeOperations = buildOperations({ drafts, media, operations });
    await NativeOfflineSync.replaceQueue({
        token,
        operations: nativeOperations,
    });

    return true;
}

export async function getNativeCompletedOfflineIds() {
    if (!isNativePlatform()) {
        return [];
    }

    const result = await NativeOfflineSync.getCompletedIds();
    return Array.isArray(result?.ids) ? result.ids.map(String) : [];
}

export async function clearNativeCompletedOfflineIds() {
    if (isNativePlatform()) {
        await NativeOfflineSync.clearCompletedIds();
    }
}

export async function setNativeForegroundActive(active) {
    if (!isNativePlatform()) {
        return;
    }

    try {
        await NativeOfflineSync.setForegroundActive({ active: Boolean(active) });
    } catch {
        // Ignorar si el método no está presente en la versión nativa actual
    }
}
